import React, { FunctionComponent, PropsWithChildren } from "react";
import Button, { ButtonProps } from "react-bootstrap/Button";

interface AnimatedLoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
}

const AnimatedLoadingButton: FunctionComponent<
  PropsWithChildren<AnimatedLoadingButtonProps>
> = ({ children, isLoading = false, ...props }) => (
  <Button
    {...props}
    data-testid="animated-loading-button"
    disabled={isLoading || props.disabled}
    className={`animated-loading-button ${props.className} ${
      isLoading ? "animated-loading-button--loading" : ""
    }`}
  >
    {children}
  </Button>
);

export default AnimatedLoadingButton;
